// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__Gh5mF","employee-header__buttons":"Header_employee-header__buttons__Jhilj","employee-header-item":"Header_employee-header-item__85TfC"};